<template>
  <div class="privacy">
		<base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
		>
		</base-banner>

		<base-goto color="white" :breadcrumbs="breadcrumbs"></base-goto>

		<div id="content">
			<div id="policy" class="sec">
				<v-container>
					<v-row justify="center">
						<p
							class="head"
							data-aos="fade-up"
							:class="MIXIN_SETUP_UI.header"
						>
							Data Privacy Statement
						</p>
					</v-row>
				</v-container>

				<v-container :class="MIXIN_SETUP_UI.defaultSidePadding">
					<v-card
						rounded="xl"
						flat
						class="card"
						data-aos="fade-up"
					>
						<v-container>
							<v-row
								class="box mb-5"
								v-for="(val, key) in policies"
								:key="key"
								data-aos="fade-up"
							>
								<v-col cols="12" sm="12" md="6" lg="6" xl="6">
									<h3>{{ val.title }}</h3>
								</v-col>
								<v-col cols="12" sm="12" md="6" lg="6" xl="6">
									<p class="pre-wrap">{{ val.description }}</p>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-container>
			</div>
		</div>
  </div>
</template>

<script>
import Repository from "@/api/repositories";
const PrivacyBannersApi = Repository.get("privacyBanners");
const PrivacyPoliciesApi = Repository.get("privacyPolicies");

export default {
  name: "Privacy",
  components: {
		//
  },
  data() {
    return {
			banner: [],
			policies: [
				// {
				// 	title: "Our Approach to Privacy",
				// 	desc: "To provide you with the best customer experience, Medgate Philippines Holdings Pty Limited-Philippine Branch (Medgate) is committed to protecting your privacy and staying transparent with the way we handle your personal information. For this, we have designed a privacy policy that will help you understand how we collect, use, store, share and protect the personal information you have entrusted us."
				// },
				// {
				// 	title: "Privacy Policy",
				// 	desc: "Our privacy policy values and protects your personal information under the Data Privacy Act of 2012 and the laws of the Philippines. Personal information simply means any information or data that can be used to distinguish, identify or contact you."
				// },
				// {
				// 	title: "Why we collect personal information?",
				// 	desc: "To improve our products and services, it is important that we collect, use, process and analyze your personal information when it is reasonable and necessary. When we can, we aggregate and anonymize this information such that you are never identified as an individual. We call this Non-Personal Information. [Aggregating simply means presenting information in segments or categories like age groups; anonymizing means removing personally identifiable information from the data."
				// },
				// {
				// 	title: "Who we share your information with?",
				// 	desc: "We do not sell, rent or lease its customer lists to third parties. We may, from time to time, contact you on behalf of external business partners about an offering that may be of interest to you. In those cases, your unique personally identifiable information (e-mail, name, address, telephone number) is not transferred to the third party. In addition, we may share data with trusted partners to help us perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to Medgate, and they are required to maintain the confidentiality of your information."
				// },
				// {
				// 	title: "How we protect your information",
				// 	desc: "The integrity, confidentiality and security of your information are particularly important to us. That’s why we strictly enforce our privacy policy and we have implemented technological, organizational and physical security measures that are designed to protect your information from unauthorized access, use, alteration and disclosure."
				// },
				// {
				// 	title: "Your choices, including how you can check and update any personal information we have about you.",
				// 	desc: "You are afforded certain rights in relation to your personal data under the Data Privacy Act of 2012, which includes the right to object to processing, the right to access your data, the right to modify of inaccurate data, and the right to erasure or blocking of data."
				// },
				// {
				// 	title: "What happens when there are changes in this policy",
				// 	desc: "From time to time, Medgate may change this privacy policy to comply with government and regulatory requirements; to adapt to new technologies and protocols; to align with industry practices; or for other legitimate purposes. You will always be provided notice if these changes are material and, if we are required by law, we will also obtain your consent."
				// },
				// {
				// 	title: "Website Privacy Policy",
				// 	desc: "The policies below are applicable to the Website and affiliate sites of Medgate Philippines Holdings Pty Limited-Philippine Branch (Medgate) found at www.medgatephilippines.com. Please be advised that the practices described in this Privacy Policy apply only to information gathered online at our Website. They do not apply to information that you may submit to us offline or to Websites maintained by other companies or organizations to which we may link or may have link through us."
				// }
			],
			breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
				{
					name: "Data Privacy Policy",
					link: "/privacy",
					active: true
				},
			]
    }
  },
  mounted() {
		this.getPrivacyBanner();
		this.getPrivacyPolicies();
  },
  methods: {
		async getPrivacyBanner() {
      try {
        const { data } = await PrivacyBannersApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let apiData = data.data[0];

          let buttons = apiData.buttons.map(button => {
            return {
              name: button.label,
              icon: button.image,
              link: button.redirect,
              color: JSON.parse(button.styling).color
            }
          });

          let banner = {
            buttons: buttons,
            image: apiData.background_image.main,
            caption: apiData.caption,
            title: apiData.title,
            titleColor: apiData.styles.titleColor,
            captionColor: apiData.styles.captionColor,
            backgroundColor: apiData.styles.backgroundColor
          }

          this.banner = banner;
        }

        console.log('[privacy-banner]', data, this.banner);
      }
      catch(error) {
        console.log(error);
      }
		},
		async getPrivacyPolicies() {
      try {
        const { data } = await PrivacyPoliciesApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });

          let policies = data.data.map(policy => {
            return {
              title: policy.title,
              description: policy.description,
            }
          });

          this.policies = policies;
        }

        console.log('[privacy-policies]', data, this.policies);
      }
      catch(error) {
        console.log(error);
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

// #header {
// 	height: 750px;
// 	background: $blue;

// 	p {
// 		color: white;
// 	}
// }

#policy {
	.card {
		padding: 5%;

		.box {
			border-bottom: 1px solid lightgray;

			h3 {
				color: $blue;
			}
		}
	}
}
</style>